var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30pt",
    height: "30pt",
    viewBox: "0 0 700 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m603.29 516.71-83.887-83.883c43.191-47.516 66.086-110.04 63.789-174.21-2.293-64.168-29.594-124.9-76.066-169.21-46.473-44.309-108.43-68.688-172.64-67.922s-125.57 26.613-170.97 72.016c-45.402 45.402-71.25 106.77-72.016 170.97s23.613 126.16 67.922 172.64c44.309 46.473 105.04 73.773 169.21 76.066 64.172 2.2969 126.69-20.598 174.21-63.789l83.883 83.883zm-486.62-248.38c0-58.789 23.352-115.17 64.922-156.74 41.57-41.57 97.953-64.922 156.74-64.922 58.789 0 115.17 23.352 156.74 64.922 41.57 41.57 64.926 97.953 64.926 156.74 0 58.789-23.355 115.17-64.926 156.74-41.57 41.57-97.953 64.926-156.74 64.926-58.789 0-115.17-23.355-156.74-64.926-41.57-41.57-64.922-97.953-64.922-156.74z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 735,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 220.503906,
    y: 735,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.953125,
    y: 735,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.015625,
    y: 735,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.105469,
    y: 735,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 511.628906,
    y: 735,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 641.828125,
    y: 735,
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.f68a539c8f7c31d0234a0914732b7347.svg";
export { ForwardRef as ReactComponent };